import React from 'react'
import { NavLink } from 'react-router-dom'
import classes from './Contact.module.css';
import facebook from '../img/icons/facebook.png';
import instagram from '../img/icons/instagram.png';
import twitter from '../img/icons/twitter.png';
import dribble from '../img/icons/dribble.png';
import MetaTags from 'react-meta-tags';


function contact(props) {
  return (
    <div> 
    <MetaTags>
      <title>Contact</title>
      <meta name="description" content="Some description." />
      <meta property="og:title" content="MyApp" />
      <meta property="og:image" content="path/to/image.jpg" />
    </MetaTags>          
      <div className={classes.head}>
      <p>Contact<span className={classes.dot}></span></p>
      <li onClick={props.Onclose}><a href=""><NavLink to="/"><img className={classes.preview} src={require("../img/icons/home.png")} alt="" /></NavLink></a></li>
      </div>
      <div className={classes.social}>
      <li><a href="https://www.facebook.com/adarsh.km.100" target="_blank"><img src={facebook} className={classes.media} alt="" /></a></li>
      <li><a href="https://www.instagram.com/adarshkm24/?hl=en" target="_blank"><img src={instagram} className={classes.media}  alt="" /></a></li>
      <li><a href="https://twitter.com/Adarshk58750173" target="_blank"><img src={twitter} className={classes.media}  alt="" /></a></li>
      <li><a href="https://dribbble.com/gabrialgracialmarques" target="_blank"><img src={dribble} className={classes.media}  alt="" /></a></li>
       </div>
    </div>
  )
}

export default contact